"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_DESIGN_EVENTS = void 0;
var ACCESS_DESIGN_EVENTS;
(function (ACCESS_DESIGN_EVENTS) {
    ACCESS_DESIGN_EVENTS["ACCESS_DESIGN"] = "ACCESS_DESIGN";
    ACCESS_DESIGN_EVENTS["ACCESS_DESIGN_SUCCESS"] = "ACCESS_DESIGN_SUCCESS";
    ACCESS_DESIGN_EVENTS["ACCESS_DESIGN_ERROR"] = "ACCESS_DESIGN_ERROR";
})(ACCESS_DESIGN_EVENTS || (exports.ACCESS_DESIGN_EVENTS = ACCESS_DESIGN_EVENTS = {}));
